import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HiCheckCircle, HiArrowRight } from "react-icons/hi2";
import { TbMail } from "react-icons/tb";

export default function HeroSubscribe() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      setEmail("");
    }, 4000);
  };

  return (
    <div className="max-w-xl">
      <AnimatePresence mode="wait">
        {submitted ? (
          <motion.div
            key="success"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.3 }}
            className="flex items-center gap-3 px-5 py-3.5 rounded-2xl bg-emerald-500/10 border border-emerald-500/20"
          >
            <HiCheckCircle className="w-5 h-5 text-emerald-400 shrink-0" strokeWidth={2} />
            <span className="text-sm text-emerald-300" style={{ fontWeight: 600 }}>
              You&apos;re in! We&apos;ll send you the best deals and drops.
            </span>
          </motion.div>
        ) : (
          <motion.form
            key="form"
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.3 }}
            onSubmit={handleSubmit}
            className="space-y-2.5"
          >
            {/* These were all set at 15–35% white, which on this black is barely
                above the background — legible on a bright studio display, not
                on a laptop in a lit room. Brought up to full white for the
                label and button, and to a readable grey for the supporting
                lines that should still sit behind them. */}
            <p className="text-[12px] text-white uppercase tracking-wider" style={{ fontWeight: 700 }}>
              Get exclusive drops & pre-sale access
            </p>
            <div className="flex gap-2">
              <div className="flex-1 relative">
                <span
                  className="pointer-events-none absolute inset-y-0 left-0 flex w-11 items-center justify-center text-white/70"
                  aria-hidden
                >
                  <TbMail className="h-4 w-4 shrink-0" strokeWidth={2} />
                </span>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="w-full rounded-2xl border border-white/20 bg-white/[0.06] py-3 pl-11 pr-4 text-sm text-white placeholder:text-white/50 transition-all focus:border-[#E52324]/20 focus:outline-none focus:ring-2 focus:ring-[#E52324]/25"
                />
              </div>
              <button
                type="submit"
                className="px-6 py-3 rounded-2xl bg-white/[0.10] border border-white/25 text-white text-sm hover:bg-white/15 transition-all flex items-center gap-2 whitespace-nowrap"
                style={{ fontWeight: 700 }}
              >
                Subscribe
                <HiArrowRight className="w-3.5 h-3.5" strokeWidth={2} />
              </button>
            </div>
            <p className="text-[10px] text-white/45">No spam, ever. Unsubscribe anytime.</p>
          </motion.form>
        )}
      </AnimatePresence>
    </div>
  );
}
